import { lazy } from 'react';

export const FolderWrapperLazy = lazy(() =>
    import(
        /* webpackChunkName: "FolderWrapper" */
        'dibs-portfolio-folder'
    )
);
